module.exports = __webpack_public_path__ + "static/img/108.8d8a091.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/108.png
// module id = 494
// module chunks = 3